import React, {useEffect, useState} from "react";
import axios from 'axios';

// Fallback-URL falls kein WordPress-Theme aktiv ist
const FALLBACK_API_URL = 'https://api.holzblecherisch.at/api/termines';
const FALLBACK_TOKEN   = '92aa28656a041c1b782c2350ddd5b29d4301c6b01be8a196f3e3a9dad398dd2f05eaec814efdb620430ca9297cbe6647aca395fb5eca824e04e052fceda84a76fe316e6a4a51942c83e9178193193ab5bb26a5fc6824cb730bf894c67d92858abf003809b7c049bd81b798211d3120d9b5eb9e41f7e72beee699ae70bf7e3ed4';

function getCurrentDate() {
    const today = new Date();
    const year  = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day   = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function formatDate(dateString) {
    const date  = new Date(dateString);
    const day   = date.getDate();
    const month = date.getMonth() + 1;
    const year  = date.getFullYear();
    return `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;
}

function formatTime(timeString) {
    if (!timeString) return '–';
    const date    = new Date(`2000-01-01T${timeString}`);
    const hours   = date.getHours();
    const minutes = date.getMinutes();
    return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
}

// Normalisiert beide API-Formate auf ein einheitliches Array
function normalizeData(data) {
    // WordPress-Format: flaches Array [{ id, datum, uhrzeit, beschreibung }, ...]
    if (Array.isArray(data)) {
        return data.map(item => ({
            id:           item.id,
            datum:        item.datum,
            uhrzeit:      item.uhrzeit,
            beschreibung: item.beschreibung,
        }));
    }
    // Strapi-Format: { data: [{ id, attributes: { Datum, Uhrzeit, Beschreibung } }, ...] }
    if (data && Array.isArray(data.data)) {
        return data.data.map(item => ({
            id:           item.id,
            datum:        item.attributes.Datum,
            uhrzeit:      item.attributes.Uhrzeit,
            beschreibung: item.attributes.Beschreibung,
        }));
    }
    return [];
}

function Timetable() {
    const [termine, setTermine] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error,   setError]   = useState(false);

    useEffect(() => {
        const wpApiUrl = window.HB_API_URL;

        let request;
        if (wpApiUrl) {
            // WordPress-Endpoint (kein Auth nötig)
            request = axios.get(wpApiUrl);
        } else {
            // Fallback: alte Strapi-API
            request = axios.get(
                `${FALLBACK_API_URL}?sort=Datum:asc&filters[Datum][$gte]=${getCurrentDate()}`,
                { headers: { Authorization: `Bearer ${FALLBACK_TOKEN}` } }
            );
        }

        request
            .then(response => {
                setTermine(normalizeData(response.data));
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError(true);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p>Termine werden geladen ...</p>;
    }

    if (error) {
        return <p>Termine konnten leider nicht geladen werden. Bitte später nochmal versuchen.</p>;
    }

    if (termine.length === 0) {
        return <p>Aktuell sind keine Termine eingetragen.</p>;
    }

    return (
        <div>
            <table className="table">
                <thead className="thead-dark text-center">
                <tr>
                    <th className="align-middle border">Datum</th>
                    <th className="align-middle border">Uhrzeit</th>
                    <th className="align-middle border">Titel</th>
                </tr>
                </thead>
                <tbody>
                {termine.map((termin, index) => (
                    <tr key={termin.id} className={index % 2 === 0 ? "bg-light" : ""}>
                        <td className="border-0">{formatDate(termin.datum)}</td>
                        <td className="border-0">{formatTime(termin.uhrzeit)}</td>
                        <td className="border-0 text-left">{termin.beschreibung}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export default Timetable;
